
import { useTranslation } from "react-i18next";
import { Card, Form, Col } from '@deere/ux.uxframe-react'
import { getTranslation } from '../../utils/utils';
import {Alert} from '@deere/ux.uxframe-react'

export default function PropiertaryInfReview({section,answer}) {

    const { t } = useTranslation();
    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3'>
                    {getTranslation(section,'description')}
                </Card.Title>                
                <Alert accessibilityLabel="Warning:" variant="warning" aria-atomic="true">
                    <h5 className="uxf-alert-title">{t('proprietary_review_warn_title')}</h5>
                    <p className="uxf-alert-description">{t('proprietary_review_warn_body')}</p>
                </Alert>                
                <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">{t('proprietary_review_warn_answer')}</Form.Label>
                    <h6>{answer}</h6>
                    </Form.Group>         
                </Form.Row>
            </Card.Body>
        </Card >
    </>)
}
